import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { EnvironmentLoader } from './environments/utils/environment-loader.util';
import { AppModule } from './modules/main/app.module';
import { APP_CONFIG } from './modules/main/providers/app.config';

EnvironmentLoader.loadEnvironment()
    .then(() => {
        const environment = EnvironmentLoader.environment;
        if (environment.PRODUCTION) {
            enableProdMode();
        }
        return platformBrowserDynamic([{ provide: APP_CONFIG, useValue: environment }]).bootstrapModule(AppModule);
    })
    .catch(err => console.error(err));
